module.exports = __webpack_public_path__ + "static/media/boy1.bbc9d3ef.png";